<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="row mb-3">
          <div class="col-lg-12">
            <v-expansion-panels flat popout hover>
              <v-expansion-panel
              >
                <v-expansion-panel-header class="bg-light">
                  <span><v-icon left>mdi-magnify</v-icon>Detaylı Arama</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="container-xxl-fluid">
                    <div class="row">
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="descriptionValue"
                            label="Açıklama"
                            filled
                            solo
                            dense
                            clearable
                        ></v-text-field>
                      </div>
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeStart)"
                                label="Tarih Aralık Başlangıç"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeStart = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeStart"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeEnd)"
                                label="Tarih Aralık Bitiş"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeEnd = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeEnd"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="currentTypeValue"
                            label="Cari Tipi"
                            :items="[
                              {value: 1, text: 'Tüm Cariler'},
                              {value: 2, text: 'Cari Kodu'},
                              {value: 3, text: 'Grup Kodu'},
                              {value: 4, text: 'Kod1 Kodu'},
                              {value: 5, text: 'Kod2 Kodu'},
                              {value: 6, text: 'Kod3 Kodu'},
                              {value: 7, text: 'Kod4 Kodu'},
                              {value: 8, text: 'Kod5 Kodu'}
                            ]"
                            item-text="text"
                            item-value="value"
                            dense
                            filled
                            solo
                            clearable
                            hide-details
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <search-select
                            :search-type="'current'"
                            @itemChange="(e) => (currentKeyValue = e)"
                            :placeholder="'Tüm Cariler'"
                        >
                        </search-select>
<!--                        <v-text-field-->
<!--                          v-model="currentKeyValue"-->
<!--                          label="Cari Veri"-->
<!--                          filled-->
<!--                          solo-->
<!--                          dense-->
<!--                        >-->

<!--                        </v-text-field>-->
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="stockTypeValue"
                            label="Stok Tipi"
                            :items="[
                      {value: 1, text: 'Tüm Stoklar'},
                      {value: 2, text: 'Stok Kodu'},
                      {value: 3, text: 'Grup Kodu'},
                      {value: 4, text: 'Kod1 Kodu'},
                      {value: 5, text: 'Kod2 Kodu'},
                      {value: 6, text: 'Kod3 Kodu'},
                      {value: 7, text: 'Kod4 Kodu'},
                      {value: 8, text: 'Kod5 Kodu'}
                  ]"
                            item-text="text"
                            item-value="value"
                            dense
                            filled
                            solo
                            placeholder=" "
                            clearable
                            hide-details
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="stockKeyValue"
                            label="Stok Veri"
                            filled
                            solo
                            dense
                        >

                        </v-text-field>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="discountTypeValue"
                            label="İndirim Tipi"
                            :items="[
                      {value: 1, text: 'Oran (Yüzde: %)'},
                      {value: 2, text: 'Tutar (Fiyat: TRY)'}
                  ]"
                            item-text="text"
                            item-value="value"
                            dense
                            filled
                            solo
                            placeholder=" "
                            clearable
                            hide-details
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="discountKeyValue"
                            label="İndirim Veri"
                            filled
                            solo
                            dense
                        >

                        </v-text-field>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="statusValue"
                            label="Durum"
                            filled
                            solo
                            dense
                            :items="[{value:1,text:'Aktif'},{value:0,text:'Pasif'}]"
                            item-value="value"
                            item-text="text"
                        ></v-select>
                      </div>
                      <div class="col-lg-12 text-end">
                        <v-btn
                            color="primary darken-1"
                            small
                            @click="_fetchStockBasketList"
                        >
                          <v-icon left>mdi-magnify</v-icon>
                          Filtrele
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div class="col-lg-12 d-flex flex-wrap">
            <div>
              <p class="text-center">Gösterilen Kayıt Sayısı</p>
              <v-btn-toggle mandatory solo dense>
                <v-btn @click="perPage = 10"> 10</v-btn>
                <v-btn @click="perPage = 20"> 20</v-btn>
                <v-btn @click="perPage = 30"> 30</v-btn>
                <v-btn @click="perPage = 50"> 50</v-btn>
              </v-btn-toggle>
            </div>
            <div class="ms-auto">
              <v-btn v-if="this.user.RoleGroupId === 1 || this.user.RoleGroupId === '1'" small color="success darken-1" @click="openNewStockBasketDialog">Kampanya Oluştur</v-btn>
            </div>
          </div>
        </div>
        <div class="row">
          <p class="text-start">Toplam <b> {{ this.stockBasketListCount}} </b> Kayıt Bulundu</p>
          <ResultTableView :perPage="perPage"></ResultTableView>
        </div>
        <!-- end row -->

        <div class="row">
          <div class="col-lg-12 mb-5">
            <v-pagination
                v-model="currentPage"
                class="my-4"
                :length="parseInt(this.stockBasketListCount / this.perPage)"
                :total-visible="20"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
    <NewStockBasketDialog
        :showDialog="showNewStockBasketDialog"
        @dialogChange="(e) => (showNewStockBasketDialog = e)"
    ></NewStockBasketDialog>
  </div>
</template>

<script>
import ResultTableView from "@/components/campaign/stocks/results/ResultsTableView";
import {formattedDate} from "@/momentHelper";
import {mapState, mapActions} from "vuex";
import NewStockBasketDialog from "@/components/campaign/stocks/dialogs/NewStockBasketDialog";
import SearchSelect from "@/components/searchSelect.vue";

export default {
  components: {
    SearchSelect,
    ResultTableView,
    NewStockBasketDialog
  },
  props: {
    listType: {
      type: String,
      default: "SiparisList"
    }
  },
  mounted() {
    //this.getOrders(this.listType);
    this._fetchBasketCategoryList();
    this._fetchStockBasketList();
  },
  computed: {
    ...mapState("basket", ["basketCategoryList","stockBasketListCount"]),
    ...mapState("cart", ["current"]),
    ...mapState("auth", ["user"]),
  },
  data() {
    return {

      perPage: 10,
      currentPage: 1,
      dateRangeStart: null,
      dateRangeEnd: null,
      showNewStockBasketDialog: false,
      currentTypeValue: null,
      currentKeyValue: null,
      stockTypeValue: null,
      stockKeyValue: null,
      discountTypeValue: null,
      discountKeyValue: null,
      descriptionValue: null,
      statusValue: 1,
    };
  },
  methods: {
    formattedDate,
    ...mapActions("basket", ["fetchBasketCategoryList", "fetchStockBasketList"]),
    _fetchBasketCategoryList() {
      this.fetchBasketCategoryList({
        params: {},
        body: {}
      });
    },
     async _fetchStockBasketList() {
      await this.fetchStockBasketList({
        params: {
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          userId: this.user.UserId,
        },
        body: {
          Description: this.descriptionValue,
          StartDate: this.dateRangeStart,
          FinishDate: this.dateRangeEnd,
          CurrentType: this.currentTypeValue,
          CurrentKey: this.currentKeyValue,
          StockType: this.stockTypeValue,
          StockKey: this.stockKeyValue,
          ValueType: this.discountTypeValue,
          ValueKey: this.discountKeyValue,
          isActive: this.statusValue ? this.statusValue : 1
        }
      });
    },
    openNewStockBasketDialog() {
      this.showNewStockBasketDialog = true;
    }
  },
  watch: {
    perPage: function (newVal) {
      newVal;
      this.currentPage = 1;
      this._fetchBasketCategoryList();
    },

    currentPage: function (newVal) {
      newVal;
      this._fetchStockBasketList();
      this._fetchBasketCategoryList();
    },
    showNewStockBasketDialog: function (newVal) {
      newVal;
      this._fetchStockBasketList();
    }
  }
};
</script>